import React from "react";
// Path adjusted since this file is in /pages/Games, while the content is in /components/Games
import SpectateTableContent from "./SpectateTableContent";
// Re-use the CSS import to ensure styles are applied
import "./SpectateGamesDashboard.css";

// This component is rendered for AUTHENTICATED users, receiving the Navbar from ProtectedLayout.
function AuthenticatedSpectatePage() {
  return (
    // Re-using the same outermost wrapper for consistent styling, but it is now nested
    // inside the ProtectedLayout's main content area.
    <div className="games-dashboard-wrapper">
      <SpectateTableContent />
    </div>
  );
}

export default AuthenticatedSpectatePage;
